import React from "react";
import Newsletter from "../Newsletter";
import "./footer.scss";

import Logo from "./../../Assets/logo/logo.PNG";
import playStore from "../../Assets/images/play-store.png";
import appStore from "../../Assets/images/app-store.png";

const Footer = () => {
  return (
    <div className="footer">
      <Newsletter />
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
            <img src={Logo} alt="logo" />
            <h5 className="my-3">Download our App on IOS and Android </h5>
            <div className="store-img my-3">
              <img src={playStore} alt="play store" />
              <img src={appStore} alt="app store" />
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
            <h4>Help</h4>
            <div className="footer-links">
              <a href="#">Search</a>
              <a href="#">Help</a>
              <a href="#">Information</a>
              <a href="#">Privacy Policy</a>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
            <h4>Support</h4>
            <div className="footer-links">
              <a href="#">Contact</a>
              <a href="#">About us</a>
              <a href="#">Careers</a>
              <a href="#">Refund and Returns</a>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
            <h4>Quick Contact</h4>
            <div className="contact my-3">
              <div className="address">
                <p>
                  <i className="fas fa-home fa-1x"></i> Budhanilkantha-10,
                  Jyotinagar
                </p>
                <p>
                  <i class="fas fa-envelope fa-1x"></i> xyz@gmail.com
                </p>
                <p>
                  <i class="fas fa-phone fa-1x"></i> +977-9806422479
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row footer-down">
          <p style={{ fontSize: "0.75rem" }}>
            All copyright reserved, 2021, StopandShop
          </p>
          <p>
            <a href="#">
              <i className="fab fa-facebook fa-1x"></i>
            </a>{" "}
            <a href="#">
              <i className="fab fa-instagram fa-1x"></i>
            </a>
            <a href="#">
              <i className="fab fa-twitter fa-1x"></i>
            </a>
            <a href="#">
              <i className="fab fa-linkedin fa-1x"></i>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
